import script from "./InviteFriend.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteFriend.vue?vue&type=script&setup=true&lang=js"

import "./InviteFriend.vue?vue&type=style&index=0&id=68d44614&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d44614"]])

export default __exports__